const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const getMonthName = (month) => {
    return months[month]
}

export { months, getMonthName }